import { useCallback, useState } from "react";
import Grid from "@mui/material/Grid";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import SessionPanel from "./components/SessionPanel";
import MetricsPanel from "./components/MetricsPanel";
import TemplatesPanel from "./components/TemplatesPanel";
import DeliveryHistoryPanel from "./components/DeliveryHistoryPanel";
import LogsPanel from "./components/LogsPanel";
import EventsPanel from "./components/EventsPanel";
import { WA_TABS_SX } from "./components/WaOutlineButton";

function WhatsApp() {
  const theme = useTheme();
  const isCompactTabs = useMediaQuery(theme.breakpoints.down("md"));
  const [tab, setTab] = useState("overview");
  const [refreshKey, setRefreshKey] = useState(0);
  const [liveSession, setLiveSession] = useState(null);

  const bumpRefresh = useCallback(() => setRefreshKey((k) => k + 1), []);

  const bumpRefreshOnSessionChange = useCallback(
    (data) => {
      if (data && typeof data === "object") {
        setLiveSession(data);
      }
      const status = data?.status;
      if (
        status === "connected" ||
        status === "disconnected" ||
        status === "paused" ||
        status === "validation_failed" ||
        status === "error"
      ) {
        bumpRefresh();
      }
    },
    [bumpRefresh]
  );

  const bumpRefreshOnLiveEvent = useCallback(
    (event) => {
      const type = event?.type;
      if (
        type === "session.connected" ||
        type === "session.disconnected" ||
        type === "validation.failed" ||
        type === "message.sent" ||
        type === "message.failed" ||
        type === "queue.updated"
      ) {
        bumpRefresh();
      }
    },
    [bumpRefresh]
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <VuiBox py={3}>
        <VuiBox mb={3}>
          <VuiTypography variant="h3" color="white" fontWeight="bold" mb={0.5}>
            WhatsApp
          </VuiTypography>
          <VuiTypography variant="button" color="text" fontWeight="regular">
            Sistema de alertas WhatsApp
          </VuiTypography>
        </VuiBox>

        <Tabs
          value={tab}
          onChange={(_, value) => setTab(value)}
          variant={isCompactTabs ? "scrollable" : "fullWidth"}
          scrollButtons={isCompactTabs ? "auto" : false}
          allowScrollButtonsMobile={isCompactTabs}
          sx={WA_TABS_SX}
        >
          <Tab label="Resumen" value="overview" />
          <Tab label="Templates" value="templates" />
          <Tab label="Historial" value="history" />
          <Tab label="Logs" value="logs" />
          <Tab label="Eventos" value="events" />
        </Tabs>

        {tab === "overview" && (
          <Grid container spacing={3}>
            <Grid item xs={12} lg={7}>
              <SessionPanel onStatusChange={bumpRefreshOnSessionChange} />
            </Grid>
            <Grid item xs={12} lg={5}>
              <EventsPanel liveDefault={false} onEvent={bumpRefreshOnLiveEvent} />
            </Grid>
            <Grid item xs={12}>
              <MetricsPanel refreshKey={refreshKey} liveSession={liveSession} />
            </Grid>
          </Grid>
        )}

        {tab === "templates" && <TemplatesPanel />}

        {tab === "history" && (
          <VuiBox mt={1}>
            <DeliveryHistoryPanel refreshKey={refreshKey} />
          </VuiBox>
        )}

        {tab === "logs" && (
          <VuiBox mt={1}>
            <LogsPanel refreshKey={refreshKey} />
          </VuiBox>
        )}

        {tab === "events" && (
          <Grid container spacing={3}>
            <Grid item xs={12} lg={7}>
              <EventsPanel onEvent={bumpRefreshOnLiveEvent} />
            </Grid>
            <Grid item xs={12} lg={5}>
              <MetricsPanel refreshKey={refreshKey} liveSession={liveSession} />
            </Grid>
          </Grid>
        )}
      </VuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default WhatsApp;
